import React, { useEffect, useRef } from "react";
import { Marker } from "react-leaflet";
import MarkerIcon from "../../atoms/MarkerIcon/MarkerIcon";

const DraggableMarker = ({ position, index, setStopMarkers, isDraggable, onDragEnd, esControl = false }) => {
    const markerRef = useRef(null);

    useEffect(() => {
        const marker = markerRef.current;
        if (!marker || !isDraggable) return;

        marker.on('dragend', (e) => {
            const { lat, lng } = e.target.getLatLng();
            setStopMarkers((prev) => {
                const updated = [...prev];
                updated[index] = { lat, lng };
                return updated;
            });
            onDragEnd?.(index, { lat, lng });
        });

        return () => { marker.off('dragend'); };
    }, [index, setStopMarkers, isDraggable, onDragEnd]);

    return <Marker position={position} draggable={isDraggable} ref={markerRef} icon={MarkerIcon(index, esControl)} />;
};

export default DraggableMarker;